export default "__VITE_ASSET__fb73d8b4__"